import { jsx as _jsx } from "react/jsx-runtime";
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { CustomerPortfolioPage } from 'routes/vendor/lazy-imports';
// import { retryImportInsideRoutesDefinition } from 'utils/lazyWithRetry';
export const accountRoutes = {
    path: `${ROUTE_PATHS.ACCOUNTS}/${ROUTE_PATHS.MATCH_ALL}`,
    element: /*#__PURE__*/ _jsx(SecureRoute, {
        children: /*#__PURE__*/ _jsx(CustomerPortfolioPage, {})
    })
};
